import * as THREE from 'three';

/**
 * 渲染器初始化模块
 * 负责创建 WebGL 渲染器，配置抗锯齿、自适应、阴影等参数
 */
export class Renderer {
  /** @type {THREE.WebGLRenderer} */
  renderer;

  constructor(canvas) {
    this.renderer = new THREE.WebGLRenderer({
      canvas,
      antialias: true,   // 抗锯齿
      alpha: false,       // 不需要透明背景
      powerPreference: 'high-performance',  // 高性能模式
    });
    this.#init();
  }

  #init() {
    const { renderer } = this;

    // 设置像素比（适配 Retina 等高 DPI 屏幕，上限为 2 防止性能溢出）
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(window.innerWidth, window.innerHeight);

    // 启用阴影
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap; // 柔和阴影

    // 色调映射（防止高光过曝）
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.2;

    // 输出色彩空间
    renderer.outputColorSpace = THREE.SRGBColorSpace;
  }

  /**
   * 窗口变化时重新设置渲染器尺寸
   * @param {number} width
   * @param {number} height
   */
  setSize(width, height) {
    this.renderer.setSize(width, height);
  }

  /** 渲染一帧 */
  render(scene, camera) {
    this.renderer.render(scene, camera);
  }

  /** 释放 GPU 资源 */
  dispose() {
    this.renderer.dispose();
  }
}
